// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/peachjar-parent-app." + "b6f60a63" + ".chunk.js";
};